import React from 'react';
import { StarIcon } from 'lucide-react';
export const TestimonialsSection = () => {
  const testimonials = [{
    quote: "ApplicantPass transformed our sales hiring process. We're now able to process 3x more candidates while finding better matches for our team.",
    author: 'Sarah Johnson',
    position: 'VP of Sales, TechCorp',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  }, {
    quote: "The sales aptitude assessment has been a game-changer. We're hiring reps who hit quota faster and stay with us longer.",
    author: 'Michael Chen',
    position: 'Sales Director, GrowthWave',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  }, {
    quote: 'As a fast-growing SaaS company, we needed a better way to scale our sales team. ApplicantPass delivered beyond our expectations.',
    author: 'Jessica Rodriguez',
    position: 'CRO, SaaSly',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  }];
  return <section id="testimonials" className="py-16 md:py-24 bg-white" data-id="element-212">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-214">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-215">
            Trusted by sales leaders
          </h2>
          <p className="text-xl text-gray-600" data-id="element-216">
            See how ApplicantPass is helping companies build high-performing
            sales teams
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-217">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-218">
              <div className="flex mb-4" data-id="element-219">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400 fill-current" data-id="element-220" />)}
              </div>
              <p className="text-gray-700 mb-6 italic" data-id="element-221">"{testimonial.quote}"</p>
              <div className="flex items-center" data-id="element-222">
                <img src={testimonial.image} alt={testimonial.author} className="h-12 w-12 rounded-full object-cover mr-4" data-id="element-223" />
                <div data-id="element-224">
                  <h4 className="text-gray-900 font-medium" data-id="element-225">
                    {testimonial.author}
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-226">
                    {testimonial.position}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};